import logo from "../assets/images/Logo Coded-Estate.svg";
import arrow_swap from "../assets/images/Header/arrow-swap.svg";
import notification_bing from "../assets/images/Header/notification-bing.svg";
import light from "../assets/images/Header/light.svg";
import arrowToDown from "../assets/images/Header/Arrow.svg";
import airplane_plane_big from "../assets/images/Header/airplane-plane-big.svg";
import hand_key from "../assets/images/Header/hand-key.svg";
import filterIcon from "../assets/images/Rent/Arrange, Filter, Sort.svg";
import arrowIcon from "../assets/images/Rent/Arrow.svg";
import search_normal from "../assets/images/Rent/search-normal.svg";
import rating_three from "../assets/images/Rent/Rating, Five, Star,.svg";
import sort_decending from "../assets/images/Rent/sort-decending(1).svg";
import sort_cending from "../assets/images/Rent/sort-decending.svg";
import short from "../assets/images/Rent/Social.svg";
import grid_layout from "../assets/images/Rent/grid-layout-14-square.svg";
import map_line from "../assets/images/Rent/map-line-small-sqaure.svg";
import pin_location from "../assets/images/Rent/Pin, Location, Direction.svg";
// import verify_user from "../assets/images/Dashboard/Dashboard/verifyUser.svg";
import verify_user from "../assets/images/verify.svg";
import bathroom_tub from "../assets/images/Rent/bathroom-tub-towel.svg";
import bed_double from "../assets/images/Rent/bed-double-3.svg";
import favorite from "../assets/images/Rent/Favorite.svg";
import heart from "../assets/images/Rent/Frame 1000005004 (1).svg";
import unheart from "../assets/images/Rent/Frame 1000005004.svg";
import nusd from "../assets/images/Rent/Frame.svg";
import guests from "../assets/images/Rent/Group.svg";
import pin from "../assets/images/Rent/Pin, Location.svg";
import arrow_right from "../assets/images/Rent/ArrowToRight.svg";
import arrow_left from "../assets/images/Rent/arrowToleft.svg";
import check_in from "../assets/images/Rent/checkIn.svg";
import check_out from "../assets/images/Rent/checkout.svg";
import baths_icon from "../assets/images/Rent/BathsOcon.svg";
import beds_icon from "../assets/images/Rent/BedsICon.svg";
import User_icon from "../assets/images/Rent/UserIcon.svg";
import home_icon from "../assets/images/Rent/HomeIcon.svg";
import calender_icon from "../assets/images/Rent/calenderIcon.svg";
import calender_icon1 from "../assets/images/Rent/CalendarIcon.svg";
import calender_colored from "../assets/images/Rent/coloredCalendar.svg";
import user_box from "../assets/images/Rent/USerbox.svg";
import usdt_svg from "../assets/images/USDT.svg";
// import eth_svg from "../assets/images/ETH.svg";
import fdusd_icon from "../assets/images/FDUSD.svg";
import dai_svg from "../assets/images/dai.svg";
import star_icon from "../assets/images/Review/Star.svg";
import value_icon from "../assets/images/Review/valuereview.svg";
import location_icon from "../assets/images/Review/locationReview.svg";
import communication_icon from "../assets/images/Review/communicationreveiw.svg";
import key_icon from "../assets/images/Review/keyreview.svg";
import accuracy_icon from "../assets/images/Review/accuracyreview.svg";
import booking_date from "../assets/images/Rent/BookingDate.svg";
import close_icon from "../assets/images/CloseIcon.svg";
import check_mark from "../assets/images/Rent/Checkmark.svg";
import copy_icon from "../assets/images/Rent/Copyicon.svg";
import ground_rules from "../assets/images/Rent/GroundRules.svg";
import host_icon from "../assets/images/Dashboard/Sidebar/hostIcon.svg";
import host_inactive from "../assets/images/Dashboard/Sidebar/hostinactive.svg";
import travler_icon from "../assets/images/Dashboard/Sidebar/travelerIcon.svg";
import travler_activeicon from "../assets/images/Dashboard/Sidebar/traveleractive.svg";
import dashboard_active from "../assets/images/Dashboard/Sidebar/dashboardActive.svg";
import dashboard_inactive from "../assets/images/Dashboard/Sidebar/dashboardInactive.svg";
import reservation_active from "../assets/images/Dashboard/Sidebar/reservationsActive.svg";
import reservation_inactive from "../assets/images/Dashboard/Sidebar/reservationsInactive.svg";
import nfts_active from "../assets/images/Dashboard/Sidebar/nftsActive.svg";
import nfts_inactive from "../assets/images/Dashboard/Sidebar/nftsInactive.svg";
import inbox_inactive from "../assets/images/Dashboard/Sidebar/inboxInactive.svg";
import inbox_active from "../assets/images/Dashboard/Sidebar/inboxActive.svg";
import unverified from "../assets/images/Dashboard/Dashboard/unverified.svg";
import tripsinactive from "../assets/images/Dashboard/Sidebar/tripsinactive.svg";
import tripsactive from "../assets/images/Dashboard/Sidebar/tripsactive.svg";
import transactionsactive from "../assets/images/Dashboard/Sidebar/transactionsactive.svg";
import transactionsinactive from "../assets/images/Dashboard/Sidebar/transactionsinactive.svg";
import empty_property from "../assets/images/Dashboard/Dashboard/emptyproperty.svg";
import empty_booking from "../assets/images/Dashboard/Dashboard/emptybooking.svg";
import empty_nft from "../assets/images/Dashboard/Dashboard/emptynft.svg";
import empty_inbox from "../assets/images/Dashboard/Dashboard/emptyinbox.svg";
import camera from "../assets/images/Dashboard/Dashboard/camera.svg";
import mint_sample from "../assets/images/Dashboard/Dashboard/mintSample.svg";
import mint_home from "../assets/images/Dashboard/Dashboard/minthome.svg";
import mint_image from "../assets/images/Dashboard/Dashboard/mintimage.svg";
import mint_upload from "../assets/images/Dashboard/Dashboard/mintupload.svg";
import map_minus from "../assets/images/Dashboard/Dashboard/mapminus.svg";
import map_plus from "../assets/images/Dashboard/Dashboard/mapplus.svg";
import map_share from "../assets/images/Dashboard/Dashboard/mapshare.svg";
import mint_guests from "../assets/images/Dashboard/Dashboard/mintguests.svg";
import mint_bedrooms from "../assets/images/Dashboard/Dashboard/mintbedrooms.svg";
import mint_bathrooms from "../assets/images/Dashboard/Dashboard/mintbathrooms.svg";
import mint_beds from "../assets/images/Dashboard/Dashboard/mintbeds.svg";
import mint_camera from "../assets/images/Dashboard/Dashboard/mintcamera.svg";
import image_icon from "../assets/images/Dashboard/Dashboard/imageicon.svg";
import delete_icon from "../assets/images/Dashboard/Dashboard/deleteicon.svg";
import building_name from "../assets/images/Dashboard/Dashboard/buildingname.svg";
import property_id from "../assets/images/Dashboard/Dashboard/propertyid.svg";
import ground_rule from "../assets/images/Dashboard/Dashboard/groundrule.svg";
import wifi from "../assets/images/Dashboard/Dashboard/wifi.svg";
import description from "../assets/images/Dashboard/Dashboard/description.svg";
import address from "../assets/images/Dashboard/Dashboard/address.svg";
import amenities from "../assets/images/Dashboard/Dashboard/amenities.svg";
import body_soap from "../assets/images/Dashboard/Dashboard/bodysoap.svg";
import hot_water from "../assets/images/Dashboard/Dashboard/hotwater.svg";
import tv from "../assets/images/Dashboard/Dashboard/tv.svg";
import air_conditioner from "../assets/images/Dashboard/Dashboard/airconditioner.svg";
import essential from "../assets/images/Dashboard/Dashboard/essential.svg";
import pets from "../assets/images/Dashboard/Dashboard/pets.svg";
import messages_inbox from "../assets/images/Dashboard/Dashboard/messagesinbox.svg";
import white_check_mark from "../assets/images/Rent/WhiteCheckMark.svg";
import plusIcon from "../assets/images/Rent/plusIcon.svg";

export const PlusIcon = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="w-max select-none p-[8px] cursor-pointer rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)]"
    >
      <img alt="" src={plusIcon} />
    </div>
  );
};

export const CheckMarkPurple = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="w-max select-none p-[5px] cursor-pointer rounded-full bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)]"
    >
      <img alt="" className="w-[14px]" src={white_check_mark} />
    </div>
  );
};

export const WhiteCheckMarkIcon = ({ className }) => {
  return <img alt="" src={white_check_mark} className={className} />;
};

export const NibiruIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2615_6459)">
        <g clip-path="url(#clip1_2615_6459)">
          <path d="M22 0H0V22H22V0Z" fill="url(#paint0_linear_2615_6459)" />
          <path
            d="M11.1669 4.14359L11.4358 3.76121L11.1669 3.57202L10.8979 3.76121L11.1669 4.14359ZM6.98921 7.08218L6.72023 6.69978L6.1855 7.07593L6.71434 7.46032L6.98921 7.08218ZM15.3445 7.08218H15.812V6.83943L15.6135 6.69978L15.3445 7.08218ZM15.3445 13.1552L15.0697 13.5334L15.812 14.073V13.1552H15.3445ZM14.973 14.9184L15.2469 15.2973L15.7695 14.9195L15.2479 14.5403L14.973 14.9184ZM6.61789 8.84539L6.89276 8.46721L6.15039 7.9276V8.84539H6.61789ZM10.9083 17.857L10.6442 18.2427L10.9156 18.4286L11.1822 18.2359L10.9083 17.857ZM6.61789 14.9184H6.15039V15.1649L6.35371 15.3042L6.61789 14.9184ZM10.8979 3.76121L6.72023 6.69978L7.25818 7.46454L11.4358 4.52596L10.8979 3.76121ZM15.6135 6.69978L11.4358 3.76121L10.8979 4.52596L15.0756 7.46454L15.6135 6.69978ZM15.812 13.1552V7.08218H14.877V13.1552H15.812ZM6.71434 7.46032L15.0697 13.5334L15.6194 12.7771L7.26407 6.704L6.71434 7.46032ZM15.2479 14.5403L6.89276 8.46721L6.34302 9.22353L14.6981 15.2966L15.2479 14.5403ZM11.1822 18.2359L15.2469 15.2973L14.6991 14.5396L10.6344 17.4781L11.1822 18.2359ZM6.35371 15.3042L10.6442 18.2427L11.1725 17.4713L6.88207 14.5327L6.35371 15.3042ZM6.15039 8.84539V14.9184H7.08539V8.84539H6.15039Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2615_6459"
          x1="-2.0324"
          y1="-2.36912"
          x2="23.0476"
          y2="-1.02899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F29AC4" />
          <stop offset="0.13" stop-color="#F2A9CB" />
          <stop offset="0.275" stop-color="#F2BAD5" />
          <stop offset="0.395" stop-color="#CDC6D7" />
          <stop offset="0.52" stop-color="#82D1D9" />
          <stop offset="0.66" stop-color="#09D4D7" />
          <stop offset="0.8" stop-color="#11BBCA" />
          <stop offset="1" stop-color="#17A0BF" />
        </linearGradient>
        <clipPath id="clip0_2615_6459">
          <rect width="22" height="22" rx="11" fill="white" />
        </clipPath>
        <clipPath id="clip1_2615_6459">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MessagesInboxIcon = ({ className }) => {
  return <img alt="" src={messages_inbox} className={className} />;
};

export const PetsIcon = ({ className }) => {
  return <img alt="" src={pets} className={className} />;
};

export const AirConditionerIcon = ({ className }) => {
  return <img alt="" src={air_conditioner} className={className} />;
};

export const EssentialIcon = ({ className }) => {
  return <img alt="" src={essential} className={className} />;
};

export const HotWaterIcon = ({ className }) => {
  return <img alt="" src={hot_water} className={className} />;
};

export const TvIcon = ({ className }) => {
  return <img alt="" src={tv} className={className} />;
};

export const AddressIcon = ({ className }) => {
  return <img alt="" src={address} className={className} />;
};

export const BodySoapIcon = ({ className }) => {
  return <img alt="" src={body_soap} className={className} />;
};

export const AmenitiesIcon = ({ className }) => {
  return <img alt="" src={amenities} className={className} />;
};

export const DescriptionIcon = ({ className }) => {
  return <img alt="" src={description} className={className} />;
};

export const WifiIcon = ({ className }) => {
  return <img alt="" src={wifi} className={className} />;
};

export const GroundRule = ({ className }) => {
  return <img alt="" src={ground_rule} className={className} />;
};

export const BuildingNameIcon = ({ className }) => {
  return <img alt="" src={building_name} className={className} />;
};

export const PropertyIdIcon = ({ className }) => {
  return <img alt="" src={property_id} className={className} />;
};

export const ImageIcon = ({ className }) => {
  return <img alt="" src={image_icon} className={className} />;
};

export const DeleteIcon = ({ className }) => {
  return <img alt="" src={delete_icon} className={className} />;
};

export const MintBedsIcon = ({ className }) => {
  return <img alt="" src={mint_beds} className={className} />;
};

export const MintCameraIcon = ({ className }) => {
  return <img alt="" src={mint_camera} className={className} />;
};

export const MintBathroomsIcon = ({ className }) => {
  return <img alt="" src={mint_bathrooms} className={className} />;
};

export const MintBedroomsIcon = ({ className }) => {
  return <img alt="" src={mint_bedrooms} className={className} />;
};

export const CameraIcon = ({ className }) => {
  return <img alt="" src={camera} className={className} />;
};

export const MintGuestsIcon = ({ className }) => {
  return <img alt="" src={mint_guests} className={className} />;
};

export const MapMinusIcon = ({ className }) => {
  return <img alt="" src={map_minus} className={className} />;
};
export const MapShareIcon = ({ className }) => {
  return <img alt="" src={map_share} className={className} />;
};
export const MapPlusIcon = ({ className }) => {
  return <img alt="" src={map_plus} className={className} />;
};

export const MintImage = ({ className }) => {
  return <img alt="" src={mint_image} className={className} />;
};

export const MintUpload = ({ className }) => {
  return <img alt="" src={mint_upload} className={className} />;
};

export const MintHome = ({ className }) => {
  return <img alt="" src={mint_home} className={className} />;
};

export const MintSample = ({ className }) => {
  return <img alt="" src={mint_sample} className={className} />;
};

export const EmptyNft = ({ className }) => {
  return <img alt="" src={empty_nft} className={className} />;
};

export const EmptyInbox = ({ className }) => {
  return <img alt="" src={empty_inbox} className={className} />;
};

export const EmptyBooking = ({ className }) => {
  return <img alt="" src={empty_booking} className={className} />;
};
export const EmptyProperty = ({ className }) => {
  return <img alt="" src={empty_property} className={className} />;
};

export const UnVerified = ({ className }) => {
  return <img alt="" src={unverified} className={className} />;
};

export const TripsInActive = ({ className }) => {
  return <img alt="" src={tripsinactive} className={className} />;
};

export const VerifyUserIcon = ({ className }) => {
  return <img alt="" src={verify_user} className={className} />;
};

export const TransactionsActive = ({ className }) => {
  return <img alt="" src={transactionsactive} className={className} />;
};

export const TransactionsInActive = ({ className }) => {
  return <img alt="" src={transactionsinactive} className={className} />;
};

export const TripsActive = ({ className }) => {
  return <img alt="" src={tripsactive} className={className} />;
};

export const InboxActive = ({ className }) => {
  return <img alt="" src={inbox_active} className={className} />;
};

export const InboxInActive = ({ className }) => {
  return <img alt="" src={inbox_inactive} className={className} />;
};

export const NftsActive = ({ className }) => {
  return <img alt="" src={nfts_active} className={className} />;
};

export const NftsInActive = ({ className }) => {
  return <img alt="" src={nfts_inactive} className={className} />;
};

export const DashboardActive = ({ className }) => {
  return <img alt="" src={dashboard_active} className={className} />;
};

export const ReservationInactive = ({ className }) => {
  return <img alt="" src={reservation_inactive} className={className} />;
};

export const ReservationActive = ({ className }) => {
  return <img alt="" src={reservation_active} className={className} />;
};

export const DashboardInActive = ({ className }) => {
  return <img alt="" src={dashboard_inactive} className={className} />;
};

export const HostActiveIcon = ({ className }) => {
  return <img alt="" src={host_icon} className={className} />;
};

export const HostInActiveIcon = ({ className }) => {
  return <img alt="" src={host_inactive} className={className} />;
};

export const TravlerInActive = ({ className }) => {
  return <img alt="" src={travler_icon} className={className} />;
};

export const TravlerActive = ({ className }) => {
  return <img alt="" src={travler_activeicon} className={className} />;
};

export const CopyIcon = ({ className }) => {
  return <img alt="" src={copy_icon} className={className} />;
};

export const GroundRuleIcon = ({ className }) => {
  return <img alt="" src={ground_rules} className={className} />;
};

export const CalendarIconRent = ({ className }) => {
  return <img alt="" src={calender_icon1} className={className} />;
};

export const BookingDateIcon = ({ className }) => {
  return <img alt="" src={booking_date} className={className} />;
};

export const CheckMarkIcon = ({ className }) => {
  return <img alt="" src={check_mark} className={className} />;
};

export const CloseIcon = ({ className }) => {
  return <img alt="" src={close_icon} className={className} />;
};

export const ColoredCalender = ({ className }) => {
  return <img alt="" src={calender_colored} className={className} />;
};

export const UserBoxIcon = ({ className }) => {
  return <img alt="" src={user_box} className={className} />;
};

export const ArrowToLeft = ({ className }) => {
  return <img alt="" src={arrow_left} className={className} />;
};

export const StarIconReview = ({ className }) => {
  return <img alt="" src={star_icon} className={className} />;
};

export const ValueIconReview = ({ className }) => {
  return <img alt="" src={value_icon} className={className} />;
};

export const LocationIconReview = ({ className }) => {
  return <img alt="" src={location_icon} className={className} />;
};

export const CommunicationIconReview = ({ className }) => {
  return <img alt="" src={communication_icon} className={className} />;
};

export const KeyIconReview = ({ className }) => {
  return <img alt="" src={key_icon} className={className} />;
};

export const AccuracyIconReview = ({ className }) => {
  return <img alt="" src={accuracy_icon} className={className} />;
};

export const CalenderIcon = ({ className }) => {
  return <img alt="" src={calender_icon} className={className} />;
};

export const HomeIcon = ({ className }) => {
  return <img alt="" src={home_icon} className={className} />;
};

export const BathsIcon = ({ className }) => {
  return <img alt="" src={baths_icon} className={className} />;
};
export const BedsIcon = ({ className }) => {
  return <img alt="" src={beds_icon} className={className} />;
};
export const UsersIcon = ({ className }) => {
  return <img alt="" src={User_icon} className={className} />;
};

export const CheckInIcon = ({ className }) => {
  return <img alt="" src={check_out} className={className} />;
};
export const CheckOutIcon = ({ className }) => {
  return <img alt="" src={check_in} className={className} />;
};

export const ArrowToRightIcon = ({ className }) => {
  return <img alt="" src={arrow_right} className={className} />;
};

export const BathRoomIconRent = ({ className }) => {
  return <img alt="" src={bathroom_tub} className={className} />;
};
export const BedIconRent = ({ className }) => {
  return <img alt="" src={bed_double} className={className} />;
};
export const FavoriteIconRent = ({ className }) => {
  return <img alt="" src={favorite} className={className} />;
};
export const HeartIconRent = ({ className, tooltip }) => {
  return (
    <img data-tooltip-id={tooltip} alt="" src={heart} className={className} />
  );
};
export const UnHeartIconRent = ({ className, tooltip }) => {
  return (
    <img alt="" data-tooltip-id={tooltip} src={unheart} className={className} />
  );
};

export const NUSDIcon = ({ className }) => {
  return <img alt="" src={nusd} className={className} />;
};

export const FDUSDIcon = ({ className }) => {
  return <img alt="" src={fdusd_icon} className={className} />;
};

export const USDTIcon = ({ className }) => {
  return <img alt="" src={usdt_svg} className={className} />;
};

// export const EthIcon = ({ className }) => {
//   return <img alt="" src={eth_svg} className={className} />;
// };

export const DAIIcon = ({ className }) => {
  return <img alt="" src={dai_svg} className={className} />;
};

export const GuestsIcon = ({ className }) => {
  return <img alt="" src={guests} className={className} />;
};
export const PinIcon = ({ className }) => {
  return <img alt="" src={pin} className={className} />;
};

export const GridLayoutIconRent = ({ className }) => {
  return <img alt="" src={grid_layout} className={className} />;
};
export const MapLineIconRent = ({ className }) => {
  return <img alt="" src={map_line} className={className} />;
};
export const PinLocationIconRent = ({ className }) => {
  return <img alt="" src={pin_location} className={className} />;
};

export const ShortRentalIcon = ({ className }) => {
  return <img alt="" src={short} className={className} />;
};

export const RatingIconRent = ({ className }) => {
  return <img alt="" src={rating_three} className={className} />;
};

export const SortIconRentDec = ({ className }) => {
  return <img alt="" src={sort_decending} className={className} />;
};

export const SortIconRentCe = ({ className }) => {
  return <img alt="" src={sort_cending} className={className} />;
};

export const SearchNormalIcon = ({ className }) => {
  return <img alt="" src={search_normal} className={className} />;
};

export const ArrowIconRent = ({ className }) => {
  return <img alt="" src={arrowIcon} className={className} />;
};

export const FilterIconRent = ({ className }) => {
  return <img alt="" src={filterIcon} className={className} />;
};

export const HandKey = ({ className }) => {
  return <img alt="" src={hand_key} className={className} />;
};

export const Airplane = ({ className }) => {
  return <img alt="" src={airplane_plane_big} className={className} />;
};

export const Logo = ({ className, onClick }) => {
  return <img alt="" src={logo} onClick={onClick} className={className} />;
};

export const SwapIconHeader = ({ className }) => {
  return <img alt="" src={arrow_swap} className={className} />;
};

export const NotificationBingIconHeader = ({ className }) => {
  return <img alt="" src={notification_bing} className={className} />;
};

export const LightIcon = ({ className }) => {
  return <img alt="" src={light} className={className} />;
};

export const ArrowToDownHeader = ({ className }) => {
  return <img alt="" src={arrowToDown} className={className} />;
};
